export enum SHORT_LINK_PERMISSIONS {
  SHORT_LINK_VIEW = 'CONTENT_SHORT_LINKVIEW',
  SHORT_LINK_WRITE = 'CONTENT_SHORT_LINKWRITE',
}
